import React, { useEffect } from 'react';

import { colors, layout } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';

import { Container, Header, Anchor, Footnote } from 'Components/core';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';
import InfoBox from 'Components/InfoBox';
import ConditionSupportImage from './images/plan_extra@2x.png';
import WholeHealth from './images/wholeHealth@2x.png';
import Martinity from './images/martinity@2x.png';

import BehaveHealth from './images/behave_health@2x.png';
import QualityCare from './images/img_QualityCareOption_730.png';
import WorkSpace from './images/img_WorkplaceExtras.png';


import { replaceAnchor } from 'Root/libs/anchor';
import styled from 'styled-components';
import { visualNames } from 'Root/store/middleware/planExtra';

export default ({match}) => {
   

  useEffect(() => {
    Api.recordAcitity(CODES.MENU_WELLNESS);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Container column maxWidth style={{ margin: 'auto' }}>
            {false && <HeaderV2 title={'Health and wellness'}></HeaderV2>}

            {getNewSyleDataVer2(state,match.params.subsection)}
            {state.guidance.resourcesMap && getNewSyleData(state)}
          </Container>
        );
      }}
    </Subscribe>
  );
};

const getNewSyleData = state => {
  return (
    <React.Fragment>
      {state.guidance.resourcesMap.EverydayCare.length > 0 && (
        <InfoBox
          header="Condition support"
          longText={
            'Managing a health condition can be hard, which is why we have programs to help you coordinate care and manage your care more easily. Whether you’re managing diabetes, heart disease, or asthma, help is just a call, tap, or click away.'
          }
          image={ConditionSupportImage}
        >
          <DivContainer>
            {state.guidance.resourcesMap.EverydayCare.map(section => {
              return (
                <InnerDiv>
                  <b>{section.name}</b>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(section.summary)
                    }}
                  ></div>
                  {renderFooter(section)}
                </InnerDiv>
              );
            })}
          </DivContainer>
        </InfoBox>
      )}
      {state.guidance.resourcesMap.ChronicCare.length > 0 && (
        <InfoBox
          header="Behavioral health"
          image={BehaveHealth}
          longText={
            'When life gets tough, it can be hard to remember you’re not alone. Your Anthem health benefits include a variety of support for your mental health and emotional well-being, which can help you take better care of all the other things that matter in your life.'
          }
        >
          <DivContainer>
            {state.guidance.resourcesMap.ChronicCare.map(section => {
              return (
                <InnerDiv>
                  <b>{section.name}</b>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(section.summary)
                    }}
                  ></div>
                  {renderFooter(section)}
                </InnerDiv>
              );
            })}
          </DivContainer>
        </InfoBox>
      )}
      {state.guidance.resourcesMap.FamilyPlanning.length > 0 && (
        <InfoBox
          header="Maternity"
          longText={
            'Our maternity programs help support you no matter where you’re at in your parenting journey. From planning a family to raising small children, there’s resources available to help you thrive.'
          }
          image={Martinity}
        >
          <DivContainer>
            {state.guidance.resourcesMap.FamilyPlanning.map(section => {
              return (
                <InnerDiv>
                  <b>{section.name}</b>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(section.summary)
                    }}
                  ></div>
                  {renderFooter(section)}
                </InnerDiv>
              );
            })}
          </DivContainer>
        </InfoBox>
      )}
    </React.Fragment>
  );
};

const headerTexts = {
  ConditionSupport:
    'Managing a health condition can be hard, which is why we have programs to help you coordinate care and manage your care more easily. Whether you’re managing diabetes, heart disease, or asthma, help is just a call, tap, or click away.',
  Maternity: 'Our maternity programs help support you no matter where you’re at in your parenting journey. From planning a family to raising small children, there’s resources available to help you thrive.',
  BehavioralHealth: 'When life gets tough, it can be hard to remember you’re not alone. Your Anthem health benefits include a variety of support for your mental health and emotional well-being, which can help you take better care of all the other things that matter in your life.',
  WholeHealthConnections: 'Staying on top of your health is important but can sometimes be hard to do on your own. We connect you to the right resources that can help you more easily meet your goals . Some programs even reward you for completing various activities to improve your health.',
  QualityCareOptions: 'Looking for a new specialist or lower cost options for surgery can be time consuming, but we have solutions to help. ',
  WorkPlaceExtras: 'Your workplace extras provide additional benefits and layers of support to help you no matter what life brings your way. '
};

const images = {

  ConditionSupport: ConditionSupportImage,
  Maternity: Martinity,
  BehavioralHealth: BehaveHealth,
  WholeHealthConnections: WholeHealth,
  QualityCareOptions: QualityCare,
  WorkPlaceExtras: WorkSpace
};

const getNewSyleDataVer2 = (state,subsection) => {



  if (!state.planExtras) {
    return null;
  }

 

  return (
    <React.Fragment>
      {state.planExtras && (
        <InfoBox
          header={visualNames[subsection]}
          longText={headerTexts[subsection]}
          image={images[subsection]}
        >
          <DivContainer>
            {state.planExtras.resource.map(section => {

                  if(section.subsection !== subsection){
                    return null;
                  }

              return (
                <InnerDiv>
                  <b>{section.name}</b>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(section.summary)
                    }}
                  ></div>
                  {renderFooter(section)}
                </InnerDiv>
              );
            })}
          </DivContainer>
        </InfoBox>
      )}
    </React.Fragment>
  );
};

const renderFooter = section => {
  if (section.footNotes && section.footNotes.length > 0) {
    return (
      <Footnote>
        {section.footNotes.map(foot => {
          return (
            <div dangerouslySetInnerHTML={{ __html: foot.footnote }}></div>
          );
        })}
      </Footnote>
    );
  }
};

const InnerDiv = styled.div`
  margin: 40px;
  margin-bottom:0px ;
  

  border-radius: 8px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 20px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
    margin:0px;
    margin-top:20px ;
  }

  > b {
    font-family: 'Elevance Sans Semibold';
    font-weight: 600;
    font-size: 23px;
    line-height: 35px;
    text-align: left;
    color: #333;
    margin-bottom: 15px;
  }
`;

const DivContainer = styled.div`
  display: grid;
 
  grid-template-columns: 1fr 1fr;
  margin-bottom: 20px;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: block;
  }
`;
